export default class GithubServices {
  constructor () {
    this.releaseApi = 'https://api.github.com/repos/rivafarabi/deckboard/releases'
  }

  fetchLatestRelease () {
    return new Promise(resolve => {
      fetch(this.releaseApi)
        .then(res => {
          return res.json()
        })
        .then(data => {
          var release = {
            version: data[0].tag_name.slice(1),
            file_name: data[0].assets[0].name,
            download_url: data[0].assets[0].browser_download_url,
            size: Math.round(data[0].assets[0].size / 1048576)
          }
          resolve(release)
        })
        .catch()
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/github-services.js